import { EpimsBaseEntityDto } from './epim-base.dto';
import { IsNotEmpty } from 'class-validator';

export class EpimsGenderDto extends EpimsBaseEntityDto {
	@IsNotEmpty() GenderName: string;
	length: number;
}
